import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, postData, putData } from 'src/utils/axios/serverHelper';
import { SYS2020_R01Dto } from './Dto_SYS2020_R01';
import { SYS2020_R01Filter } from './Store_SYS2020_R01';

const baseUrl = `${config.apiUrl}/SYS2020_R01`;

export const getSYS2020_R01List = async (
	option: string,
	params: Partial<SYS2020_R01Filter>,
	listLength: number = 0,
) => getData<ResponseDto<SYS2020_R01Dto[]>>(`${baseUrl}/${option}`, {
	params: { ...params, listLength },
});

export const getSYS2020_R01AllCount = async (params: Partial<SYS2020_R01Filter>) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params });

export const postSYS2020_R01 = async (data: SYS2020_R01Dto[]) =>
	postData<SYS2020_R01Dto[], ResponseDto<SYS2020_R01Dto[]>>(baseUrl, data);

export const patchSYS2020_R01 = async (data: SYS2020_R01Dto[]) =>
	putData<SYS2020_R01Dto[], ResponseDto<SYS2020_R01Dto[]>>(baseUrl, data);

export const deleteSYS2020_R01 = async (commentCd: string) =>
	deleteData<ResponseDto<any>>(`${baseUrl}/${commentCd}`);

export const exportSYS2020_R01Excel = async (
	option: string,
	params: Partial<SYS2020_R01Filter>,
	listLength: number = 0,
) => getData<ResponseDto<string>>(`${baseUrl}/excel/${option}`, {
	params: { ...params, listLength },
});
